import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

type DateInput = string | Date | dayjs.Dayjs | null | undefined;

/**
 * Member/policy dates are stored as SAST wall-clock values. Adding 2 hours before
 * API serialization prevents local midnight from shifting to the previous UTC day.
 */
export const toMemberApiDate = (value: DateInput) => {
  if (value == null || value === "") return undefined;
  const parsed = dayjs(value);
  if (!parsed.isValid()) return undefined;
  return parsed.add(2, "hour");
};

/** Inception date must be the 1st of the selected month in SAST wall-clock storage. */
export const toMemberApiInceptionDate = (value: DateInput) => {
  if (value == null || value === "") return undefined;
  const parsed = dayjs(value);
  if (!parsed.isValid()) return undefined;
  return parsed.startOf("month").add(2, "hour");
};

/**
 * Transaction.Date / DateProcessed are stored as SAST wall-clock digits in
 * MySQL DATETIME (serialized by the API as UTC components). Format with UTC
 * so the UI does not apply a second +2h local offset.
 */
export const formatTransactionDateTime = (
  date: string | Date | null | undefined,
  format = "YYYY-MM-DD HH:mm:ss"
): string => {
  if (date == null || date === "") return "-";
  return dayjs.utc(date).format(format);
};

export const formatTransactionDate = (
  date: string | Date | null | undefined,
  format = "YYYY/MM/DD"
): string => {
  if (date == null || date === "") return "-";
  return dayjs.utc(date).format(format);
};
